import React from 'react';
import PropTypes from 'prop-types';

const renderField = ({
  input,
  label,
  placeholder,
  type,
  meta: { touched, error, warning },
  icon: Icon,
  disabled,
  className = ''
}) => (
  <div className={`form__form-group ${className}`}>
    {label && <span className="form__form-group-label">{label}</span>}
    <div className="form__form-group-field">
      <div className={`input-group input-group-sm ${touched && error ? 'has-validation' : ''}`}>
        {Icon && (
          <span className="input-group-text bg-light border-end-0 text-muted" style={{ padding: '0.25rem 0.5rem' }}>
            <Icon style={{ fontSize: '1rem' }} />
          </span>
        )}
        <input
          {...input}
          placeholder={placeholder}
          type={type}
          disabled={disabled}
          className={`form-control form-control-sm ${touched && error ? 'is-invalid' : ''} ${Icon ? 'border-start-0' : ''}`}
          style={{ fontSize: '0.85rem' }}
        />
        {touched && ((error && <div className="invalid-feedback">{error}</div>) || (warning && <div className="text-warning small">{warning}</div>))}
      </div>
    </div>
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }),
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  disabled: PropTypes.bool,
  className: PropTypes.string
};

export default renderField;